import { nullable } from '@infl-ts/util-io-ts';
import * as t from 'io-ts';
export var ShippingAddress = t.type({
  country: t.string,
  fullName: t.string,
  address: t.string,
  address2: nullable(t.string),
  city: t.string,
  region: nullable(t.string),
  postalCode: t.string,
  phoneNumber: t.string
});
export var Address = t.intersection([t.type({
  __typename: t.literal('Address')
}), ShippingAddress]);
var Error = t.type({
  message: t.string
});
export var EditShippingAddressOutput = t.type({
  editShippingAddress: t.union([t.type({
    __typename: t.literal('EditShippingAddressErrors'),
    errors: t.array(Error)
  }), t.type({
    __typename: t.literal('EditShippingAddressResult'),
    address: nullable(ShippingAddress)
  })])
});